import type { Screen } from './types';

export const authScreens: Screen[] = [
  'landing',
  'welcome',
  'createAccount',
  'legalTerms',
  'legalPrivacy',
  'legalCookies',
];
